if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
        this.selectors = { variantIdSelect: '[name="id"]' };
      }

      get sectionId() { return this.dataset.originalSection || this.dataset.section; }
      get productId() { return this.getAttribute('data-product-id'); }
      get isPrecommande() { return this.getAttribute('data-is-precommande') === 'true'; }
      get isMultiOptions() { return this.getAttribute('data-multi-options') === 'true'; }
      get select() { return this.querySelector('select'); }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('.sticky-atc-bar__btn');
        this.variantData = this.getVariantData();

        var selectedInput = this.querySelector(this.selectors.variantIdSelect);
        this.selectedVariantId = selectedInput ? selectedInput.value : null;
        this.currentVariant = this.variantData.find((v) => v.id === Number(this.selectedVariantId));

        this.init();

        // Multi-options: scroll to variant picker
        if (this.submitButton && this.submitButton.hasAttribute('data-scroll-to-variants')) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            var target = this.mainProductInfo || this.productFormActions;
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          });
        }

        // Single-option: redirect to main form if custom properties required
        if (this.submitButton && !this.submitButton.hasAttribute('data-scroll-to-variants')) {
          var mainForm = this.mainProductInfo;
          if (mainForm && mainForm.querySelectorAll('[data-custom-property]').length > 0) {
            this.submitButton.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => { this.productFormActions.requestSubmit(); }, 300);
            });
          }
        }

        // Select change
        if (this.select) {
          this.select.addEventListener('change', (e) => {
            if (this.isUpdating) return;
            this.isUpdating = true;

            this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
            var selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
            this.currentVariant = this.variantData.find((v) => v.id === Number(selectedVariantId));

            if (this.mainVariantSelects) {
              Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
                var val = this.currentVariant.options[index];
                switch (element.tagName) {
                  case 'SELECT':
                    element.value = val;
                    element.querySelectorAll('option').forEach((o) => o.removeAttribute('selected'));
                    var sel = element.querySelector(`option[value="${val}"]`);
                    if (sel) sel.setAttribute('selected', 'selected');
                    break;
                  case 'FIELDSET':
                    element.querySelectorAll('input').forEach((r) => { if (r.value === val) r.checked = true; });
                    break;
                }
              });
              setTimeout(() => {
                this.mainVariantSelects.dispatchEvent(new Event('change'));
                this.isUpdating = false;
              }, 0);
            } else {
              this.isUpdating = false;
            }

            this.updatePrice();
            this.updateButton();
          });
        }
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      formatMoney(cents) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }

      getButtonLabel() {
        var v = this.currentVariant;
        if (!v || (!v.available && !this.isPrecommande)) return FoxTheme.variantStrings.soldOut;
        var price = ' - ' + this.formatMoney(v.price);
        if (this.isMultiOptions) return 'Voir les options' + price;
        if (this.isPrecommande) return 'Precommander' + price;
        return FoxTheme.variantStrings.addToCart + price;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        var mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.container.classList[entry.intersectionRatio !== 1 ? 'add' : 'remove']('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin: '-80px 0px 0px 0px' }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton() {
        if (!this.submitButton) return;
        var span = this.submitButton.querySelector('span');
        var v = this.currentVariant;
        if (!v || (!v.available && !this.isPrecommande)) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (span) span.textContent = FoxTheme.variantStrings.soldOut;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (span) span.textContent = this.getButtonLabel();
        }
      }

      updatePrice() {
        var pw = this.querySelector('.sticky-atc-bar__product .f-price');
        if (!pw || !this.currentVariant) return;
        var v = this.currentVariant;
        var fmt = FoxTheme.settings.moneyFormat;

        pw.classList.toggle('f-price--on-sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        pw.classList.toggle('f-price--sold-out', !v.available);

        var sale = pw.querySelector('.f-price-item--sale');
        if (sale) sale.innerHTML = FoxTheme.Currency.formatMoney(v.price, fmt);
        pw.querySelectorAll('.f-price-item--regular').forEach((el) => {
          el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
            ? FoxTheme.Currency.formatMoney(v.compare_at_price, fmt)
            : FoxTheme.Currency.formatMoney(v.price, fmt);
        });
        var uw = pw.querySelector('.f-price__unit-wrapper');
        if (uw) uw.classList.add('hidden');
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          if (!this.mainProductInfo || event.data.sectionId !== this.mainProductInfo.dataset.section) return;
          var variant = event.data.variant;
          var input = this.querySelector('[name="id"]');
          if (input) input.value = variant.id;
          this.currentVariant = variant;
          this.updatePrice();
          this.updateButton();
        });
      }
    }
  );
}
